import MarketCourseService from '../../../../services/MarketCourseService';
import abzhanovaDilara from './abzhanova-dilara.jpg';
import adekenovaUmit from './adekenova-umit.jpg';
import akshalovaAinash from './akshalova-ainash.jpg';
import edilkhanDidar from './edilkhan-didar.jpg';
import ibadildinNurkhat from './ibadildin-nurkhat.jpg';
import mukushevMedet from './mukushev-medet.jpg';
import sharipovErkanat from './sharipov-erkanat.jpg';

/**
 * Фотографии преподавателей, приехавшие вместе с курсами из документов заказчика.
 *
 * Лежат в репозитории, потому что заливаются в БД сидом при первом старте — на
 * проде их некому было бы загрузить через админку. Фотографии, добавленные позже
 * через админку, хранятся на бэкенде: для них срабатывает вторая ветка.
 *
 * Явная карта, а не require.context: тот работает только в сборке webpack
 * и падает в тестах.
 */
export const TRAINER_PHOTOS = {
    'abzhanova-dilara.jpg': abzhanovaDilara,
    'adekenova-umit.jpg': adekenovaUmit,
    'akshalova-ainash.jpg': akshalovaAinash,
    'edilkhan-didar.jpg': edilkhanDidar,
    'ibadildin-nurkhat.jpg': ibadildinNurkhat,
    'mukushev-medet.jpg': mukushevMedet,
    'sharipov-erkanat.jpg': sharipovErkanat,
};

/**
 * URL фотографии по имени файла из trainer.photo.
 * null — если поля нет: витрина тогда рисует силуэт.
 */
export const trainerPhoto = (fileName) => {
    if (!fileName) return null;
    return TRAINER_PHOTOS[fileName] || MarketCourseService.photoUrl(fileName);
};

export default trainerPhoto;
